import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import DynamicPopover from '../../utils/dynamic-popover'
import { fetchApiData } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'
import ResourceTile from './resource-tile'

const selectResources = state => state.resources
const selectResourceUuid = (state, uuid) => uuid

const makeResource = createSelector(
    [selectResources, selectResourceUuid],
    (resources, uuid) => resources.find(resource => resource.uuid === uuid)
)

const mapStateToProps = (state, ownProps) => {
    const resource = makeResource(state, ownProps.uuid)
    return { resource }
}

const ResourcesPopover = ({ dispatch, resource, linkText, uuid }) => {
    useEffect(() => {
        // If we have the resource, we don't need to fetch it again
        if (resource) {
            return
        }
        // Otherwise, fetch the resource data
        dispatch(fetchApiData(apiResourceEndpoint('resources', 'VIEW', uuid)))
    }, [dispatch, resource, uuid])

    const onToggleOpen = () => {
        // If we dont have the resource, fetch it
        if (!resource) {
            dispatch(fetchApiData(apiResourceEndpoint('resources', 'VIEW', uuid)))
        }
    }

    if (!resource) {
        return (
            <DynamicPopover onToggleOpen={onToggleOpen} linkText={linkText} isLoading={true} />
        )
    }
    let dataFields = {
        'data-clicktext': linkText.replace(/"/g, '\\"'),
        'data-resourcetype': resource.resource_type,
        'data-resourcetitle': resource.title.replace(/"/g, '\\"')
    }
    return (
        <DynamicPopover onToggleOpen={onToggleOpen} linkText={linkText} isLoading={false} dataFields={dataFields}>
            <ResourceTile resource={resource} />
        </DynamicPopover>
    )
}
export default connect(mapStateToProps)(ResourcesPopover)
